// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"750":"c1a2e41c","923":"72097cca"}[chunkId] + ".chunk.js";
};